import { Text } from "components/ui/Text";
import { Layout } from "components/ui/Layout";
import { Spinner } from "common/ui/Spinner";

import { setProjectId } from "common/middleware/store";
import { useProjects } from "common/middleware/hooks";

import styles from "./ProjectList.module.scss";

export function ProjectList() {
  const { projects } = useProjects();

  return (
    <>
      {projects ? (
        <div className={styles.ProjectList}>
          <Text.MainTitle>Choose a project</Text.MainTitle>
          <Layout.Flex direction="column" gap12>
            {projects.entities.map((project) => (
              <div
                key={project.id}
                className={styles.Project}
                onClick={() => setProjectId(project.id.toString())}
              >
                <Text.Body inline>{project.name}</Text.Body>
              </div>
            ))}
          </Layout.Flex>
        </div>
      ) : (
        <Spinner />
      )}
    </>
  )
};
